import type { HTMLAttributes } from "react";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
  padding?: "sm" | "md" | "lg";
}

const PADDING = {
  sm: "var(--space-3)",
  md: "var(--space-5)",
  lg: "var(--space-6)",
};

/** Soft-shadow rounded surface — the primary content container in this app. */
export function Card({ interactive, padding = "md", style, className, ...rest }: CardProps) {
  return (
    <div
      {...rest}
      className={className}
      style={{
        background: "var(--color-panel)",
        border: "1px solid var(--color-border)",
        borderRadius: "var(--radius-lg)",
        boxShadow: "var(--shadow-md)",
        padding: PADDING[padding],
        minWidth: 0,
        maxWidth: "100%",
        overflowWrap: "anywhere",
        transition: "box-shadow var(--duration-standard) var(--ease-standard), transform var(--duration-standard) var(--ease-standard)",
        cursor: interactive ? "pointer" : undefined,
        ...style,
      }}
      onMouseEnter={(e) => {
        if (interactive) e.currentTarget.style.boxShadow = "var(--shadow-card-hover)";
      }}
      onMouseLeave={(e) => {
        if (interactive) e.currentTarget.style.boxShadow = "var(--shadow-md)";
      }}
    />
  );
}
